import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../../services/global';
import { BaseCrudComponent } from '../../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, of, throwError, from } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import * as moment from 'moment-timezone';

import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import {MessageService} from 'primeng/api';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Lightbox } from 'ngx-lightbox';

@Component({
  selector: 'app-monitoring',
  templateUrl: './monitoring.component.html',
  styleUrls: ['./monitoring.component.css']
})
export class MonitoringComponent extends BaseCrudComponent {

	id:any;
    lat: number = -2.1503614;
    lng: number = -79.9015386;
    /*lat:any;
    lng:any;*/
    zoom: number = 10;//11
  	customers:any;
  	showSidebar = false;
  	loadingRequired = false;
  	reception = false;
  	evaluation = false;
  	fields:any;
  	files:any;
  	c_obj:any;

  	currentRate = 3;

  	translations:any;
    momentjs: any = moment;
    curr_date:any;
    today:any;
    dstart:any;

    status:any;
    assigned:any;
    route_obj:any;

    isTracking:any;
    marker_track = "data:image/png;base64,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";
    track_lat:any;
    track_lng:any;

    delivery_states:any;

    notif_refresh_time = 15000;
    notiftimer:any;
    current_route:any;
    first_call = true;
    media_url = '';

    sel_rows:any;
    branch_marker = Global.branch_marker;

    constructor(
        srv: ApiService,
        modalService: NgbModal,
        storage: Storage,
        router: Router,
        private route: ActivatedRoute,
        public translate: TranslateService,
        private _lightbox: Lightbox
      ) {
        super(srv, modalService, storage, router);
        this.read_url = 'LogisticRoute/GetLocations';
        this.create_url = '';
        this.update_url = '';
        this.delete_url = '';
        this.search_fields = ['routeName', 'driverName'];
        this.clearData();
        this.clearCurrentData();
        this.media_url = Global.url + 'LogisticClient/media/';
        this.sel_rows = [];
    }

    clearData(){
    	super.clearData();
    }

    clearCurrentData(){
    	this.current_route = {id:0, name:'', driver:'', lat:'', lng:'', open:false, status:'', customers:[]};
      this.sel_rows = [];
      this.zoom = 10;
    }

    ngOnInit() {
        this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');

        this.translate.getTranslation(this.translate.currentLang)
        .subscribe((translations) => {
                this.translations = translations;
                super.ngOnInit();
                this.getList();

                //activate timer t report position
                var curr = this;
                this.notiftimer = setInterval(function(){ curr.getList(); }, this.notif_refresh_time);
        });

    }

    getList(){
        //this.clearData();
        this.loadingList = true;
        this.srv.getCall(this.read_url).subscribe(x => {
            var data = x.data;
            this.loadingList = false;

            if(x.status){

                if( Array.isArray(data) && (data.length > 0) ){
                    let tmp:any;
                    tmp = [];

                    data.forEach(d => {
                        d.open = false;
                    });

                    this.rows = data;
                    this.rawdata = data;
                    this.filterAll();

                    this.sel_rows = [];
                    this.rows.forEach(r => {
                        //console.log(r);
                        if( (this.current_route != undefined) && (r.routeId == this.current_route.id) ){
                            this.sel_rows.push(r);
                            //this is used to follow truck position
                            /*this.lat = parseFloat(r.latitude);
                            this.lng = parseFloat(r.longitude);*/
                        }
                    });
                }

              	if( this.first_call && Array.isArray(data) && (data.length > 0) ){
              		this.lat = data[0].latitude;
              		this.lng = data[0].longitude;
              	}

              	this.first_call = false;
            }
        }),
        //timeout(MAX_TIME),
        catchError(data => {return of(false)})
    }

    public getDetails(obj:any){
        var par_url = 'LogisticRoute/GetDestinationsByRoute/' + obj.id;

        this.loadingRequired = true;
        this.srv.getCall(par_url).subscribe(x => {
            var data = x.data;
            this.loadingRequired = false;

            if(x.status){
              	let mydata:any = {status: false, message:'', data:[]};
                mydata = x;
                
                if(mydata.status == true ){
                  	//console.log(mydata.data);
                  	if( Array.isArray(mydata.data) ){
                  		  let rs = mydata.data[0];
                  		  //obj.customers = rs.destinations;
                  		  let i = 0;
              			    rs.destinations.forEach(d => {
                  				  let coords = d.coordinate.split(';');

                    				/*if(i == 0){
                    					 this.lat = parseFloat(coords[0]);
                    					 this.lng = parseFloat(coords[1]);
                    				}*/

                            let tmp:any;
                            tmp = null;
                            if( Array.isArray(d.delivery) && (d.delivery.length >= 0) ){
                                tmp = d.delivery[0];
                            }

                    				obj.customers.push({
                      					name: d.clientName,
                      					lat: parseFloat(coords[0]),
                      					lng: parseFloat(coords[1]),
                      					status: '',
                      					hour: '',
                      					address: d.recipientAddress,
                      					city: d.recipientCity,
                      					phone: d.recipientPhone,
                      					invoice: d.invoiceNumber,
                      					guide: d.guideNumber,
                      					details: d.details,
                      					comment: d.comment,
                      					color: '',
                                delivered: d.isDelivered,
                                notdelivered: d.isNotDelivered,
                                delivery_details: tmp,
                                isSubsidiary: d.isSubsidiary
                    				});

                  				  i++;
                  			});
                  		  //console.log(obj);
                  	}
                }
            }
        }),
        //timeout(MAX_TIME),
        catchError(data => {return of(false)})
    }

  	showCustomerDetails(content:any, obj:any){
    		this.reception = false;
    		this.evaluation = false;
    		this.u_obj = obj;
    		//this.u_obj['img'] = [];
        
        if( obj.isSubsidiary ){
            Swal.fire('Arribo Hivimar', '', 'info');
            return;
        }

    		this.modalService.open(content, { centered: true });
  	}

  	setCurrentRoute(obj:any){
    		this.clearCurrentData();
    		this.current_route.id = obj.routeId;
    		this.current_route.name = obj.routeName;
    		this.current_route.driver = obj.driverName;
        this.current_route.status = obj.routeStatusName
    		//this.enableSidebar();
        this.disableSidebar();

        this.sel_rows = [];
        this.sel_rows.push(obj);
        this.lat = parseFloat(obj.latitude);
        this.lng = parseFloat(obj.longitude);
        this.zoom = 13;
        
        this.getDetails(this.current_route);
  	}

  	disableSidebar(){
  		  this.showSidebar = false;
  	}

  	enableSidebar(){
  		  this.showSidebar = true;
  	}

  	public closeModal(content: any) {
	     this.modalService.dismissAll(content);
	  }

    clearTimers(){
        clearInterval(this.notiftimer);
    }

    ngOnDestroy(){
        this.clearTimers();
    }

    public showReception(){
        this.reception = true;
        this.evaluation = false;
    }

    public showEvaluation(){
        this.reception = false;
        this.evaluation = true;
    }

    public hideReception(){
        this.reception = false;
        this.evaluation = false;
    }

    openPreview(img:any): void {
      var album:any;
      album = [
        {src: img}
      ];
        // open lightbox
        this._lightbox.open(album, 0);
    }

}
